import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.jpeg";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar${scrolled ? " scrolled" : ""}`}>
      <div className="nav-flex">

        {/* LOGO */}
        <Link to="/" className="logo">
          <img src={logo} alt="Cleanwave Essentials" />
          <div className="logo-text">
            <span className="logo-brand">Cleanwave Essentials</span>
            <span className="logo-sub">Neatryx &mdash; Premium Cleaning Solutions</span>
          </div>
        </Link>

        {/* NAVIGATION */}
        <nav>
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/products">Products</NavLink>
          <NavLink to="/OtherSupplies">Other Supplies</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "nav-cta active" : "nav-cta"}>
            Contact
          </NavLink>
        </nav>

      </div>
    </header>
  );
}

export default Navbar;